module.exports = __webpack_public_path__ + "app/principal/invited-buyer-relations-1oDTqxG8.html";